import gql from 'graphql-tag'

export const validateRecaptcha = gql`
  mutation validateRecaptcha($recaptchaResponse: String) {
    validateRecaptcha(recaptchaResponse: $recaptchaResponse) {
      success
    }
  }
`
